import React from 'react';
import { Heart, ArrowUp } from 'lucide-react';
import { personalInfo as mockInfo } from '@/mock';
import '../styles/Footer.css';

const Footer = ({ settings }) => {
  // Use settings from API or fallback to mock
  const info = settings || mockInfo;

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-brand">
            <h3 className="footer-logo">{info.name}</h3>
            <p className="footer-tagline">
              Building mobile experiences that scale to millions
            </p>
          </div>

          <div className="footer-links">
            <div className="footer-column">
              <h4 className="footer-heading">Navigation</h4>
              <ul className="footer-list">
                <li><a href="#home">Home</a></li>
                <li><a href="#about">About</a></li>
                <li><a href="#experience">Experience</a></li>
                <li><a href="#projects">Projects</a></li>
              </ul>
            </div>

            <div className="footer-column">
              <h4 className="footer-heading">Connect</h4>
              <ul className="footer-list">
                <li><a href={info.linkedin} target="_blank" rel="noopener noreferrer">LinkedIn</a></li>
                <li><a href={info.github} target="_blank" rel="noopener noreferrer">GitHub</a></li>
                <li><a href={`mailto:${info.email}`}>Email</a></li>
                <li><a href={`tel:${info.phone}`}>Phone</a></li>
              </ul>
            </div>

            <div className="footer-column">
              <h4 className="footer-heading">Resources</h4>
              <ul className="footer-list">
                <li><a href="#skills">Skills</a></li>
                <li><a href="#articles">Articles</a></li>
                <li><a href="#contact">Contact</a></li>
              </ul>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="footer-copyright">
            © {new Date().getFullYear()} {info.name}
          </p>
          
          <button className="back-to-top" onClick={scrollToTop}>
            <ArrowUp size={20} />
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
